import Vue from 'vue'
import moment from 'moment'
import API from '@/api'
import { autoscheduleConstants } from '@/constants'

export default {
  async getAutoSchedulesUnits({ commit }) {
    await this.dispatch('GET_UNITS')
    const { data: config } = await API.autoschedule.getAutoscheduleConfig()

    const data = config.focusGroupUnits.map(id => this.getters['units'].filter(unit => unit.id === id)).flat()

    commit('changeCommonData', {
      storageField: '',
      key: 'units',
      value: data,
    })
    commit('changeCommonData', {
      storageField: '',
      key: 'autoscheduleSettings',
      value: config,
    })
  },
  getGraph({ commit, state }, { fieldName, apiMethod }) {
    commit('changeAutoscheduleData', {
      field: fieldName,
      key: 'getDataInProgress',
      value: true,
    })

    const { selectedUnit, selectedMonth } = state.commonData
    const data = {
      unit_id: selectedUnit.id,
      begin_at: `${selectedMonth}-1`,
      end_at: `${selectedMonth}-${moment(selectedMonth).daysInMonth()}`,
    }

    if (state.graphsSettings.mode) {
      data.service_category_id = state.graphsSettings.mode
    }

    API.autoschedule[apiMethod](data)
      .then(({ data }) => {
        commit('changeAutoscheduleData', {
          field: fieldName,
          key: 'graphData',
          value: data,
        })
      })
      .catch(() => {
        commit('changeAutoscheduleData', {
          field: fieldName,
          key: 'statisticsError',
          value: true,
        })
      })
      .finally(() => {
        if (fieldName !== 'forecasting') {
          commit('changeAutoscheduleData', {
            field: fieldName,
            key: 'getDataInProgress',
            value: false,
          })
        }
      })
  },
  getQuarantineWorkplaces({ commit }) {
    API.autoschedule.getQuarantineWorkplaces().then(({ data }) => {
      commit('changeAutoscheduleData', {
        field: 'forecasting',
        key: 'quarantineData',
        value: data,
      })
    })
  },
  saveQuarantineWorkplaces({ state, commit }, payload) {
    API.autoschedule.saveQuarantineWorkplaces({
      ...payload,
      unit_id: state.commonData.selectedUnit.id,
    })
  },
  deleteQuarantineWorkplaces({ commit }, settingId) {
    API.autoschedule.deleteQuarantineWorkplaces(settingId)
  },
  updateForecastGraph({ state }, payload) {
    return API.autoschedule.updateForecastGraph({
      unit_id: state.commonData.selectedUnit.id,
      data: payload,
      service_category_id: state.graphsSettings.mode || autoscheduleConstants.manicureCategoryId,
    })
  },
  getWishesData({ state, commit }) {
    const { selectedUnit, selectedMonth } = state.commonData

    API.autoschedule
      .getWishesData({
        unit_id: selectedUnit.id,
        begin_at: `${selectedMonth}-01`,
        end_at: `${selectedMonth}-${moment(selectedMonth).daysInMonth()}`,
      })
      .then(({ data }) => {
        const formattedData = {}

        data.employers.forEach(employer => {
          formattedData[employer.id] = employer
        })

        commit('changeAutoscheduleData', {
          field: 'mastersTable',
          key: 'employerWishesData',
          value: formattedData,
        })
      })
  },
  getMastersTable({ commit }, unitId) {
    commit('changeAutoscheduleData', {
      field: 'mastersTable',
      key: 'inProgress',
      value: true,
    })

    API.autoschedule
      .getEmployers({
        unit_id: unitId,
      })
      .then(({ data }) => {
        commit('changeAutoscheduleData', {
          field: 'mastersTable',
          key: 'data',
          value: data,
        })
      })
      .catch(() => {
        commit('changeAutoscheduleData', {
          field: 'mastersTable',
          key: 'error',
          value: true,
        })
      })
      .finally(() => {
        commit('changeAutoscheduleData', {
          field: 'mastersTable',
          key: 'inProgress',
          value: false,
        })
      })
  },
  getSchedule({ state, commit }, apiMethod) {
    const { selectedUnit, selectedMonth } = state.commonData
    let params = {
      unit_id: selectedUnit.id,
      begin_at: `${selectedMonth}-01`,
      end_at: `${selectedMonth}-${moment(selectedMonth).daysInMonth()}`,
    }

    commit('changeAutoscheduleData', {
      field: 'forecasting',
      key: 'getDataInProgress',
      value: true,
    })

    if (state.graphsSettings.mode) {
      params = {
        ...params,
        service_category_id: state.graphsSettings.mode,
      }
    }

    API.autoschedule[apiMethod](params)
      .then(({ data: { employers, stats } }) => {
        commit('changeAutoscheduleData', {
          field: 'forecasting',
          key: 'scheduleData',
          value: employers,
        })
        commit('changeAutoscheduleData', {
          field: 'forecasting',
          key: 'daysData',
          value: stats,
        })
      })
      .catch(() => {})
      .finally(() => {
        commit('changeAutoscheduleData', {
          field: 'forecasting',
          key: 'getDataInProgress',
          value: false,
        })
      })
  },
  saveSchedule({ state }) {
    API.autoschedule.saveSchedule({
      unit_id: state.commonData.selectedUnit.id,
    })
  },
  recalculateForecastingCeil({ state, commit }, { employer, date }) {
    API.autoschedule
      .getSchedule({
        unit_id: state.commonData.selectedUnit.id,
        employer_id: employer.id,
        begin_at: date,
        end_at: date,
      })
      .then(({ data: { employers, stats } }) => {
        const employer = employers[0]
        const employerIndex = state.forecasting.scheduleData.findIndex(item => item.id === employer.id)

        commit('changeItemInSchedules', {
          employer,
          stats,
          employerIndex,
        })
        commit('pushScheduleItemDataForForecasting')
        commit('changeAutoscheduleData', {
          key: 'ceilUpdatingInProgress',
          field: 'forecasting',
          value: false,
        })
      })
  },
  updateScheduleItem({ state, commit, dispatch }, { employer, date, readySchedule }) {
    const Promises = []
    const schedules = employer.schedules[date]

    commit('changeAutoscheduleData', {
      key: 'ceilUpdatingInProgress',
      field: 'forecasting',
      value: true,
    })

    if (schedules) {
      schedules.forEach(scheduleItem => {
        Promises.push(
          API.autoschedule.updateScheduleItem({
            ...scheduleItem,
            unit_id: state.commonData.selectedUnit.id,
          }),
        )
      })
    } else {
      Promises.push(API.autoschedule.updateScheduleItem(readySchedule))
    }

    Promise.all(Promises).then(() => {
      dispatch('recalculateForecastingCeil', {
        employer,
        date,
      })
    })
  },
  createScheduleItem({ commit }, payload) {
    API.autoschedule.createScheduleItem(payload)
  },
  createOptionItem({ state }, { name, type, value }) {
    return API.autoschedule.createOption({
      employer_id: state.commonData.selectedMaster.id,
      name,
      type,
      value,
    })
  },
  updateOptionItem({ state }, payload) {
    const { id, name, value, description, type, readOnly } = payload

    API.autoschedule.updateOption(
      {
        employer_id: state.commonData.selectedMaster.id,
        read_only: readOnly,
        name,
        type,
        value,
        description,
      },
      id,
    )
  },
  getEmployerOptions({ state }) {
    return API.autoschedule.getOptions({
      employer_id: state.commonData.selectedMaster.id,
    })
  },
  saveMastersRating({ state, dispatch }, payload) {
    API.autoschedule
      .saveRating({
        employer_id: state.commonData.selectedMaster.id,
        value: payload,
      })
      .then(() => {
        dispatch('getMastersRatings')

        Vue.notify({
          group: 'hasBottomNavigation',
          title: '',
          type: 'success',
          text: 'Рейтинг успешно сохранен',
        })
      })
  },
  getMastersRatings({ state, commit }) {
    const { selectedMaster, selectedUnit } = state.commonData
    API.autoschedule
      .getRatings({
        unit_id: selectedUnit.id,
      })
      .then(({ data }) => {
        if (data[selectedMaster.id]) {
          const coeffObject = data[selectedMaster.id].find(
            item => item.rating_type.id === autoscheduleConstants.managerCorrectionCoeffId,
          )

          commit('changeAutoscheduleData', {
            field: 'masterPage',
            key: 'ratingObject',
            value: {
              rating: data[selectedMaster.id],
              ratingCoeffValue: (coeffObject && coeffObject.value) || 0,
            },
          })
        } else {
          commit('changeAutoscheduleData', {
            field: 'masterPage',
            key: 'ratingObject',
            value: {
              rating: [],
              ratingCoeffValue: 0,
            },
          })
        }
      })
  },
  getScheduleOpinion({ state, commit }, requestMode) {
    const {
      commonData: { selectedUnit, selectedMaster, selectedMonth },
    } = state
    const idKey = requestMode === 'unit' ? 'unit_id' : 'employer_id'

    API.autoschedule
      .getScheduleOpinion({
        [idKey]: requestMode === 'unit' ? selectedUnit.id : selectedMaster.id,
        month: moment(selectedMonth).format('YYYY-MM'),
      })
      .then(({ data }) => {
        const fieldName = requestMode === 'unit' ? 'forecasting' : 'masterPage'

        commit('changeAutoscheduleData', {
          key: 'opinionData',
          field: fieldName,
          value: data,
        })
      })
  },
  sendNeighbourRequest({ state, dispatch }, { date, employerData, time = null, employerId = null }) {
    let body = {
      unit_id: state.commonData.selectedUnit.id,
      employer_id: employerId || employerData.id,
      date,
    }

    if (time) {
      body = {
        ...body,
        time,
      }
    }

    API.autoschedule
      .sendNeighbourRequest(body)
      .then(() => {
        dispatch('recalculateForecastingCeil', {
          employer: employerData,
          date,
        })
        Vue.notify({
          group: 'hasBottomNavigation',
          type: 'success',
          text: 'Запрос на сотрудника успешно отправлен',
        })
      })
      .catch(() => {
        Vue.notify({
          group: 'hasBottomNavigation',
          type: 'error',
          text: 'Ошибка сервера',
        })
      })
  },
  changeNeighbourRequest({ dispatch }, { scheduleId, date, employerData, apiMethod }) {
    API.autoschedule[apiMethod]({
      schedule_id: scheduleId,
    })
      .then(() => {
        dispatch('recalculateForecastingCeil', {
          employer: employerData,
          date,
        })

        Vue.notify({
          group: 'hasBottomNavigation',
          type: 'success',
          text: 'Ответ на запрос мастера успешно отправлен',
        })
      })
      .catch(() => {
        Vue.notify({
          group: 'hasBottomNavigation',
          type: 'error',
          text: 'Ошибка сервера',
        })
      })
  },
  getWorkplacesNumber({ state, commit }) {
    API.autoschedule.getWorkplacesNumber(state.commonData.selectedUnit.id).then(
      ({
        data: {
          data: { items },
        },
      }) => {
        commit('changeAutoscheduleData', {
          field: 'forecasting',
          key: 'workplacesNumber',
          value: items.filter(item => item.is_reserve === false).length,
        })
      },
    )
  },
  sendRememberNotify(context, payload) {
    API.autoschedule
      .sendRememberNotify({
        subject_id: payload,
        // шлем пуш именно в нашу компанию, не франшизы
        company_id: 1,
      })
      .then(() => {
        Vue.notify({
          group: 'hasBottomNavigation',
          type: 'success',
          text: 'Оповещение успешно отправлено',
        })
      })
      .catch(() => {
        Vue.notify({
          group: 'hasBottomNavigation',
          type: 'error',
          text: 'Оповещение не отправлено',
        })
      })
  },
  passwordConfirm(context, password) {
    return API.autoschedule.passwordConfirm({
      phone: this.getters['user'].phone,
      password,
    })
  },
}
